import { render } from "./AddSchoolYearDataTable.vue?vue&type=template&id=17c4583e"
import script from "./AddSchoolYearDataTable.vue?vue&type=script&lang=js"
export * from "./AddSchoolYearDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__